import { useMemo } from 'react';

import path from 'path';

import { useTranslation } from 'react-i18next';

import { pagePathSegments } from '~constants';
import { UserRoleEnum } from '~enums';
import { DevicesOverviewContainer, SelectedDevicesProvider } from '~features/devices';
import useAuthorize from '~hooks/useAuthorize';
import DeviceListType from '~interfaces/deviceListType';
import PageLayout from '~layouts/page/pageLayout';

interface DevicePageProps {
	deviceListType: DeviceListType;
}

const DevicesPage = ({ deviceListType }: DevicePageProps) => {
	const { t } = useTranslation('entities');
	const authorize = useAuthorize();

	let listType = deviceListType;
	// When we're super admin we'll load the internal endpoint down the line
	if (
		listType == 'assigned' &&
		authorize.authorize([UserRoleEnum.SuperAdmin, UserRoleEnum.Support])
	) {
		listType = 'assignedInternal';
	}

	const tabs = useMemo(
		() => [
			{
				key: pagePathSegments.Assigned,
				// TODO: Temporary solution, because now we can't show assigned devices
				// { title: t('assigned', { ns: 'status' }),
				title: t('general.all', { ns: 'entities' }),
				path: path.join('/', pagePathSegments.Devices, pagePathSegments.Assigned),
				component: <DevicesOverviewContainer deviceListType={listType} />,
			},
			{
				key: pagePathSegments.Unassigned,
				title: t('unassigned', { ns: 'status' }),
				path: path.join('/', pagePathSegments.Devices, pagePathSegments.Unassigned),
				allowedRoles: [UserRoleEnum.SuperAdmin, UserRoleEnum.Support],
				component: (
					<SelectedDevicesProvider>
						<DevicesOverviewContainer deviceListType={listType} />
					</SelectedDevicesProvider>
				),
			},
		],
		[listType]
	);

	return (
		<PageLayout
			pageTitle={t('device.labels.plural')}
			headerInfo={{
				title: t('device.labels.plural'),
			}}
			tabs={tabs}
			activeTabKey={deviceListType}
		/>
	);
};

export default DevicesPage;
